<template>
    <div class="actions">
        <div class="box">
            <div class="actions-func">
                <Button class="margin-r10 shadow112006" icon="md-return-left" @click="$router.go(-1)">{{$t('back')}}</Button>
                <Button class="margin-r10 shadow112006" type="info" icon="md-add" @click="openAddModal">{{$t('addDevice')}}</Button>
                <Button class="shadow112006" type="error" icon="md-trash" @click="openDelModal">{{$t('b_removeDevice')}}</Button>
            </div>
            <slot name="headerExtra"></slot>
        </div>
        <!-- 添加设备 -->
        <Modal v-model="isShowAdd" @on-ok="doAdd" @on-cancel="isShowAdd = false" width="800" :ok-text="$t('ok')" :cancel-text="$t('cancel')">
            <p slot="header">
                <Icon type="md-add"/>
                <span>{{$t('addDevice')}}</span>
            </p>
            <div class="list">
                <Table border ref="devicesList" :columns="columns" :data="freeDevices" @on-selection-change="selectionChange"></Table>
            </div>
        </Modal>
        <!-- 移除设备 -->
        <Modal v-model="isShowDel" @on-ok="doDel" @on-cancel="isShowDel = false" width="800">
            <p slot="header">
                <Icon type="md-trash"/>
                <span>{{$t('b_removeDevice')}}</span>
            </p>
            <div class="list">
                <Table border ref="devicesList" :columns="columns" :data="devices" @on-selection-change="selectionChange"></Table>
            </div>
        </Modal>
    </div>
</template>
<script>
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';
import Moment from 'moment';
export default {
    props: {
        devices: Array,
        gid: [Number, String]
    },
    data() {
        return {
            isShowAdd: false, // 是否显示添加设备对话框
            isShowDel: false, // 是否显示删除设备对话框
            freeDevices: [], // 空闲设备
            selections: [], // 选中的设备
            columns: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                    renderHeader: (h, params) => {
                        return h('span', {}, this.$t('deviceName'));
                    },
                    key: 'name'
                },
                {
                    renderHeader: (h, params) => {
                        return h('span', {}, this.$t('deviceSerial'));
                    },
                    key: 'order_code'
                },
                {
                    renderHeader: (h, params) => {
                        return h('span', {}, this.$t('deviceType'));
                    },
                    render: (h, params) => {
                        return h('div', {}, this.$root.deviceKindArr[params.row.kind]);
                    }
                },
                {
                    renderHeader: (h, params) => {
                        return h('span', {}, this.$t('addTime'));
                    },
                    render: (h, params) => {
                        let created = '';
                        if (params.row.created != '') {
                            created = Moment(params.row.created).format('YYYY-MM-DD HH:mm:ss');
                        }
                        return h('span', {}, created);
                    }
                }
            ]
        };
    },
    mounted() {
        // this.getFreeDevices();
    },
    methods: {
        // selectAll(val) {
        //     this.$refs.devicesList.selectAll(val);
        // },
        // 打开添加设备对话框
        openAddModal() {
            this.isShowAdd = true;
            this.getFreeDevices();
            this.selections = [];
        },
        openDelModal() {
            this.isShowDel = true;
            this.selections = [];
        },
        // 获取空闲设备
        getFreeDevices() {
            Axios.get(AxiosUrl.device.select, {
                params: {
                    cid: this.$store.state.user.cid,
                    gid: 0
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.freeDevices = res.data.data;
                } else {
                    console.log(res.data.msg);
                }
            });
        },
        // 设备-多选
        selectionChange(selection) {
            this.selections = selection;
        },
        // 添加设备确认
        doAdd() {
            if (this.selections.length == 0) {
                this.$Message.error(this.$('deviceEmpty'));
                return;
            }
            let ids = [];
            this.selections.forEach(v => {
                ids.push(v.dev_id);
            });
            Axios.get(AxiosUrl.group.adddevicebatch, {
                params: {
                    dev_ids: ids.join('-'),
                    gid: this.gid
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.$emit('on-device-change'); // 设备变更事件冒泡
                } else {
                    console.log(res.data.msg);
                }
            });
        },
        // 移除设备确认
        doDel() {
            if (this.selections.length == 0) {
                this.$Message.error(this.$('deviceEmpty'));
                return;
            }
            let ids = [];
            this.selections.forEach(v => {
                ids.push(v.dev_id);
            });
            Axios.get(AxiosUrl.group.releasedevicebatch, {
                params: {
                    dev_ids: ids.join('-'),
                    gid: this.gid
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.$emit('on-device-change'); // 设备变更事件冒泡
                } else {
                    console.log(res.data.msg);
                }
            });
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/views/group/components/actions.vue